
    // this file was auto generated by python script
    import Monitor from './Monitor';
    export default Monitor;
    